/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Carousel from 'react-bootstrap/Carousel';
import GalleryStore from '../../../legacy/flux/stores/GalleryStore';
import MemberStore from '../../../legacy/flux/stores/MemberStore';

import GalleryActionCreators from '../../../legacy/flux/actions/GalleryActionCreators';

class MemberProfileCarousel extends React.Component {
    state = {
      images: GalleryStore.getMemberImages(this.props.memberId),
      member: MemberStore.get(this.props.memberId),
    };

    onChange = () => {
      this.setState({
        images: GalleryStore.getMemberImages(this.props.memberId),
        member: MemberStore.get(this.props.memberId),
      });
    };

    componentDidMount() {
      const { memberId } = this.props;
      console.log('memberId', memberId);
      if (!memberId) {
        return;
      }

      GalleryStore.addChangeListener(this.onChange);

      const { images } = this.state;
      if (!images) {
        GalleryStore.setLoad(true);
        GalleryActionCreators.galleryLoad(memberId);
      }
    }

    componentWillUnmount() {
      GalleryStore.removeChangeListener(this.onChange);
    }

    render() {
      const {
        id,
        name,
        image,
        sex,
        myId,
        myImage,
        needAbo,
        verificationRestrictions,
      } = this.props;

      const carouselItems = () => {
        const { images } = this.state;

        console.log('images', images);

        if (!images) {
          return;
        }

        return images.map((image, index) => (
          <Carousel.Item key={index}>
            <a
              href="/"
              data-file={image.file.split('.')[0]}
              data-member-id={id}
              className="op-gallery-open"
            >
              <img
                src={`${get(globals, 'gcloudUri', '/')}l/${image.file}.jpg`}
                className=""
                alt={name}
              />
            </a>
          </Carousel.Item>
        ));
      };

      const memberImage = () => {
        if (!image) {
          let filename = 'blank';
          if (sex) {
            filename += `-${sex.toLowerCase()}`;
          }

          return (
            <img
              src={`${get(globals, 'staticImageUri', '/')}profile/${filename}.png`}
              className="memberImage-item"
              alt={name}
            />
          );
        }

        const img = (
          <img
            src={`${get(globals, 'gcloudUri', '/')}o-n/${image}`}
            className=""
            alt={name}
          />
        );

        if (myId !== id) {
          if (verificationRestrictions) {
            return (<a href="/" data-show-popup="messages/profile_verification_message">{img}</a>);
          }
          if (!myImage) {
            return (<a href="/" data-show-popup="images/upload_popup?show_no_image_popup=true">{img}</a>);
          }
          if (needAbo) {
            return (<a href="/" data-show-popup="messages/subscription_message">{img}</a>);
          }
        }

        return (
          <Carousel nextLabel="" prevLabel="">
            <Carousel.Item>
              <a
                href="/"
                data-file={image.split('.')[0]}
                data-member-id={id}
                className="op-gallery-open"
              >
                {img}
              </a>
            </Carousel.Item>
            <Carousel.Item>
              <a
                href="/"
                data-file={image.split('.')[0]}
                data-member-id={id}
                className="op-gallery-open"
              >
                {img}
              </a>
            </Carousel.Item>
          </Carousel>
        );
      };

      let showCarouselControls = true;
      if ((this.state.images != null && this.state.images.length < 2) || this.props.compact) {
        showCarouselControls = false;
      }

      return (
        <div className="">
          <div className={`memberImage memberImage--l ${this.props.compact ? ' carousel-compact' : ''}`}>
            <Carousel
              nextLabel=""
              prevLabel=""
              interval={null}
              controls={showCarouselControls}
              indicators={showCarouselControls}
            >
              {carouselItems()}
            </Carousel>
          </div>
        </div>
      );
    }
}

MemberProfileCarousel.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
  sex: PropTypes.string,
  myId: PropTypes.string.isRequired,
  myImage: PropTypes.string,
  needAbo: PropTypes.bool,
  verificationRestrictions: PropTypes.bool,
};

MemberProfileCarousel.defaultProps = {
  image: null,
  sex: null,
  myImage: '',
  needAbo: false,
  verificationRestrictions: false,
};

export default MemberProfileCarousel;
